import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TransactionCategory } from 'app/shared';
import { Transaction } from 'app/shared/data/interfaces/Transaction';

@Component({
    selector: 'app-transaction',
    templateUrl: './transaction.component.html',
    styleUrls: ['./transaction.component.scss'],
    standalone: false
})
export class TransactionComponent implements OnInit {
  // Send back the elements to the parent (transaction-list) (if clicked)
  @Output() alterTransaction = new EventEmitter<Transaction>();
  @Output() deleteTransaction = new EventEmitter<Transaction>();

  @Input() transactionCategory: TransactionCategory;

  constructor() {}

  ngOnInit() {}
}
